import { createSlice } from '@reduxjs/toolkit'
import { RootState, WidgetState } from 'types/state'

const initialState: WidgetState = {
  isOpened: false,
  showHelpMessage: false,
}

export const widgetSlice = createSlice({
  name: 'widget',
  initialState,
  reducers: {
    setIsOpened: (state: WidgetState, action) => {
      state.isOpened = action.payload
      window.parent.postMessage({ type: 'toggleWidget', payload: action.payload }, '*')
    },
    toggleWidget: (state: WidgetState) => {
      state.isOpened = !state.isOpened
      window.parent.postMessage({ type: 'toggleWidget', payload: state.isOpened }, '*')
    },
  },
})

export const { setIsOpened, toggleWidget } = widgetSlice.actions
export const selectIsOpened = (rootState: RootState) => rootState.widgetState.isOpened
export default widgetSlice.reducer
